import { Chip, Grid } from "@mui/material";
import EditAction from "../components/edit-action/edit-action";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { dateString } from "@/common/components/TableView/helpers/helpers";
import indianNumberFormatComponent from "@/common/helpers/indianNumberFormatComponent";
const { schemeStatusMasterKey } = requestedMenuAll;
const { updateKey } = requestedFeaturesAll;

// Scheme status mapping
const SCHEME_STATUS_MAP = {
  '8': { text: 'Waiting for Approval', backgroundColor: '#05ad0aff', textColor: '#ffffff' },
  '9': { text: 'GM Rejected', backgroundColor: '#d32f2f', textColor: '#ffffff' },
  '10': { text: 'GM Pending', backgroundColor: '#ff9800', textColor: '#ffffff' },
  '12': { text: 'BH Pending', backgroundColor: '#03a9f4', textColor: '#ffffff' },
  '11': { text: 'CH Pending', backgroundColor: '#9c27b0', textColor: '#ffffff' },
  '14': { text: 'AH Pending', backgroundColor: '#3f51b5', textColor: '#ffffff' },
  '16': { text: 'CH Rejected', backgroundColor: '#e64a19', textColor: '#ffffff' },
  '17': { text: 'BH Rejected', backgroundColor: '#7b1fa2', textColor: '#ffffff' },
  '18': { text: 'AH Rejected', backgroundColor: '#1565c0', textColor: '#ffffff' },
  default: { text: 'Unknown', backgroundColor: '#607d8b', textColor: '#ffffff' },
};

function schemeStatusColor(status) {
  return SCHEME_STATUS_MAP[String(status)] || SCHEME_STATUS_MAP.default;
}

function darkenColor(color, factor = 0.8) {
  const hex = color.replace('#', '');
  const r = Math.max(0, Math.min(255, parseInt(hex.substring(0, 2), 16) * factor));
  const g = Math.max(0, Math.min(255, parseInt(hex.substring(2, 4), 16) * factor));
  const b = Math.max(0, Math.min(255, parseInt(hex.substring(4, 6), 16) * factor));
  return `#${Math.round(r).toString(16).padStart(2, '0')}${Math.round(g).toString(16).padStart(2, '0')}${Math.round(b).toString(16).padStart(2, '0')}`;
}

export const columns = ({
  onRowEdit, isUpdateDeleteAccess
}) => ([...[

  {
    header: 's-no',
    accessorKey: 'id',
    cell: (value) => {
      const id = value.row.index + 1;
      console.log('columns-id', id)
      return id;
    }
  },
  {
    header: 'product-name',
    accessorKey: 'productName',
  },
  // {
  //   header: 'scheme-type', 
  //   accessorKey: 'schemeType', 
  // }, 
  // { 
  //   header: 'year',
  //   accessorKey: 'schemeYear', 
  // }, 
  {
    header: 'month',
    accessorKey: 'schemeMonth',
  },
  {
    header: 'value',
    accessorKey: 'schemeTotal',
    cell: (value) => {
      let tv = indianNumberFormatComponent(value.row.original.schemeTotal);
      return tv;
    }
  },
  {
    header: 'total-cus',
    accessorKey: 'noOfCustomerCount',
  },
  {
    header: "eligible",
    accessorKey: "eligiblecount",
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <span
          style={{
            color: val > 0 ? "green" : "inherit",
            fontWeight: val > 0 ? "bold" : "normal",
          }}
        >
          {val || 0}
        </span>
      );
    },
  },
  {
    header: "reject",
    accessorKey: "rejectcount",
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <span
          style={{
            color: val > 0 ? "red" : "inherit",
            fontWeight: val > 0 ? "bold" : "normal",
          }}
        >
          {val || 0}
        </span>
      );
    },
  },
  {
    header: "requested",
    accessorKey: "manualcount",
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <span
          style={{
            color: val > 0 ? "#f4b400" : "inherit",
            fontWeight: val > 0 ? "bold" : "normal",
          }}
        >
          {val || 0}
        </span>
      );
    },
  },
  {
    header: "unplanned",
    accessorKey: "unplannedcount",
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <span
          style={{
            color: val > 0 ? "red" : "inherit",
            fontWeight: val > 0 ? "bold" : "normal",
          }}
        >
          {val || 0}
        </span>
      );
    },
  },
  {
    header: 'created-at',
    hideColumn: true,
    accessorKey: 'createdAt',
    cell: ({ getValue }) => dateString(getValue())
  },
  {
    header: 'created-by',
    hideColumn: true,
    accessorKey: 'createdBy'
  },
  {
    header: 'updated-at',
    hideColumn: true,
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => dateString(getValue())
  },
  {
    header: 'updated-by',
    hideColumn: true,
    accessorKey: 'updatedBy'
  },
  {
    header: 'status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const status = getValue();
      const { text: statusText, backgroundColor, textColor } = schemeStatusColor(status);
      return (
        <Chip
          label={statusText}
          size="small"
          sx={{
            background: `linear-gradient(145deg, ${backgroundColor}, ${darkenColor(backgroundColor, 0.8)})`,
            color: textColor,
            borderRadius: '16px',
            padding: '6px 12px',
            fontWeight: '600',
            boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.3), -2px -2px 4px rgba(255, 255, 255, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            '&:hover': {
              boxShadow: '3px 3px 6px rgba(0, 0, 0, 0.4), -3px -3px 6px rgba(255, 255, 255, 0.3)',
            },
          }}
        />
      );
    },
  },
  {
    header: 'status',
    hideColumn: true,
    accessorKey: 'activeStatus',
    cell: (cell) => {
      switch (cell.getValue()) {
        case '0':
          return <Chip color="error" label="In-Active" size="small" variant="light" />;
        case '1':
        default:
          return <Chip color="success" label="Active" size="small" variant="light" />;
      }
    }
  }
],
...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={schemeStatusMasterKey} requestedFeature={updateKey}>
          <Grid item>
            <EditAction
              {...props}
              onRowEdit={onRowEdit}
            />
          </Grid>
        </VerifyAccess>
        {/* <VerifyAccess requestedMenu={ifdCompetitorMasterKey} requestedFeature={deleteKey}>
        <Grid item>
        <DeleteAction
          {...props}
          onRowDelete={onRowDelete} deleteCompetitorMasterStatus={deleteCompetitorMasterStatus}
        />
        </Grid>
        </VerifyAccess> */}
      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }
] : [])]);

const CUS_REJECT_STATUS_MAP = {
  '5': { text: 'GM Rejected', backgroundColor: '#d32f2f', textColor: '#ffffff' },
  '7': { text: 'CH Rejected', backgroundColor: '#e64a19', textColor: '#ffffff' },
  '9': { text: 'BH Rejected', backgroundColor: '#7b1fa2', textColor: '#ffffff' },
  '11': { text: 'AH Rejected', backgroundColor: '#1565c0', textColor: '#ffffff' },
  default: { text: 'Unknown', backgroundColor: '#607d8b', textColor: '#ffffff' },
};

export function cusRejectStatusColor(status) {
  return CUS_REJECT_STATUS_MAP[String(status)] || CUS_REJECT_STATUS_MAP.default;
}

export const rejectedSchemeColumns = ({
  onViewDetailed, isUpdateDeleteAccess
}) => ([
  {
    header: 's-no',
    accessorKey: 'id',
    cell: (value) => value.row.index + 1
  },
  {
    header: 'Scheme Name',
    accessorKey: 'schemeName',
  },
  {
    header: 'Period',
    accessorKey: 'schemePeriod',
  },
  {
    header: 'Rejected Customers',
    accessorKey: 'rejectedCount',
    cell: ({ getValue }) => (
      <span style={{ color: 'red', fontWeight: 'bold' }}>
        {getValue()}
      </span>
    )
  },
  {
    header: 'Status',
    accessorKey: 'status',
    cell: ({ getValue }) => {
      const status = getValue();
      const config = schemeStatusColor(status);
      return (
        <Chip
          label={config.text}
          size="small"
          sx={{
            backgroundColor: config.backgroundColor,
            color: config.textColor,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            fontSize: '10px'
          }}
        />
      );
    }
  },
  {
    header: 'action',
    id: "view",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <Grid item>
          <EditAction
            {...props}
            onRowEdit={() => onViewDetailed(props.row.original)}
            tooltipTitle="View Customers"
          // icon="eye" // Assuming EditAction can take an icon or we just use it as a "View" button
          />
        </Grid>
      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }
]);

export const rejectedColumns = ({
  onRowEditCustomer, isUpdateDeleteAccess
}) => ([...[
  {
    header: 's-no',
    accessorKey: 'id',
    cell: (value) => value.row.index + 1
  },
  {
    header: 'Customer Code',
    accessorKey: 'customerCode',
  },
  {
    header: 'Customer Name',
    accessorKey: 'customerName',
  },
  {
    header: 'Scheme Name',
    accessorKey: 'schemeNameParent',
  },
  {
    header: 'Target MTS',
    accessorKey: 'targetMts',
    cell: ({ getValue, row }) => {
      const val = getValue();
      const { minMts, maxMts } = row.original;
      
      // Handle Maida categorical target MTS (JSON string)
      if (typeof val === 'string' && val.trim().startsWith('{')) {
        try {
          const obj = JSON.parse(val);
          const entries = Object.entries(obj).filter(([_, v]) => v !== '' && v !== null && v !== 0 && v !== '0');
          return (
            <div style={{ color: 'blue', fontWeight: 'bold' }}>
              {entries.map(([k, v], i) => (
                <span key={k}>
                  {k}: {v}{i < entries.length - 1 ? ', ' : ''}
                </span>
              ))}
              {entries.length === 0 ? 0 : ''}
            </div>
          );
        } catch (e) {
          return val;
        }
      }
      
      return (
        <span style={{ color: 'blue', fontWeight: 'bold' }}>
          {val ? Math.round(val) : (minMts && maxMts ? `${minMts}-${maxMts}` : 0)}
        </span>
      );
    }
  },
  {
    header: 'Sales',
    accessorKey: 'monthSales',
    cell: ({ getValue }) => {
      const val = getValue();
      if (typeof val === 'string' && val.startsWith('{')) {
        try {
          const obj = JSON.parse(val);
          return Object.values(obj).reduce((a, b) => a + Number(b), 0).toFixed(2);
        } catch (e) { return val; }
      }
      return Number(val || 0).toFixed(2);
    }
  },
  {
    header: 'Amount',
    accessorKey: 'eligibleSchemeAmount',
    cell: ({ getValue }) => indianNumberFormatComponent(getValue())
  },
  {
    header: 'Status',
    accessorKey: 'schemeStatus',
    cell: ({ getValue }) => {
      const status = getValue();
      const { text: statusText, backgroundColor, textColor } = cusRejectStatusColor(status);
      return (
        <Chip
          label={statusText}
          size="small"
          sx={{
            background: `linear-gradient(145deg, ${backgroundColor}, ${darkenColor(backgroundColor, 0.8)})`,
            color: textColor,
            borderRadius: '16px',
            padding: '6px 12px',
            fontWeight: '600',
            boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.3), -2px -2px 4px rgba(255, 255, 255, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
          }}
        />
      );
    },
  },
],
...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={schemeStatusMasterKey} requestedFeature={updateKey}>
          <Grid item>
            {/* Reusing EditAction, but mapping it to onRowEditCustomer */}
            <EditAction
              {...props}
              onRowEdit={onRowEditCustomer}
            />
          </Grid>
        </VerifyAccess>
      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }
] : [])]);

export const reportFileName = "Scheme Status Master";
